export default __webpack_public_path__ + "static/media/techblogpic.7665d126.png";